import { baseQuery } from '../baseQuery';

type RescheduleServiceParams = {
  appointmentStart?: string;
  reasonId?: number;
  jobId: string;
  technicianIds: string[];
  isTechnicianConfirmed?: 0 | 1;
  isAvailabilityOverrideEnabled: boolean;
};

export const putService = async ({
  appointmentStart,
  reasonId,
  jobId,
  technicianIds,
  isTechnicianConfirmed,
  isAvailabilityOverrideEnabled,
}: RescheduleServiceParams) => {
  const { data } = await baseQuery('service', {
    type: 'PUT',
    body: {
      appointment_start: appointmentStart,
      reason_id: reasonId,
      service_id: jobId,
      technician_list: technicianIds,
      technician_confirmed: isTechnicianConfirmed,
      // availability override
      override_availability: Number(isAvailabilityOverrideEnabled),
    },
  });

  return data;
};
